import BaseOptionsBundle from "%/dynamic-component-editor/classes/base-options";
import PlaceholderText from "%/dynamic-component-editor/options/placeholder-text";
import QuickPostPrompt from "%/dynamic-component-editor/options/quick-post-prompt";
import QuickPostShowCharacterCount from "%/dynamic-component-editor/options/quick-post-show-character-count";
import QuickPostSurface from "%/dynamic-component-editor/options/quick-post-surface";
import QuickPostImageShape from "%/dynamic-component-editor/options/quick-post-image-shape";
export default class QuickPostOptions extends BaseOptionsBundle {

  optionTitle = "Quick Post Options";
  static optionClassName = "i-quick-post";

  constructor(values = {}) {
    super(values, [
      QuickPostPrompt,
      PlaceholderText,
      QuickPostShowCharacterCount,
      QuickPostSurface,
      QuickPostImageShape,
    ]);
  }
}
